import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPartyConfetti = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Bold",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "party-confetti" }),
		/* @__PURE__ */ _jsx("path", { d: "M23.21,11.807a.748.748,0,0,1-.53-.22,3.152,3.152,0,0,0-4.352,0,.75.75,0,0,1-1.061-1.061,4.579,4.579,0,0,1,6.473,0,.751.751,0,0,1-.53,1.281Z" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20.764,
			cy: 14.563,
			r: .809
		}),
		/* @__PURE__ */ _jsx("path", { d: "M12.943,6.953a.75.75,0,0,1-.53-1.28,3.084,3.084,0,0,0,0-4.353A.75.75,0,0,1,13.473.26a4.583,4.583,0,0,1,0,6.473A.744.744,0,0,1,12.943,6.953Z" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9.437,
			cy: 3.236,
			r: .809
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 23.191,
			cy: .809,
			r: .809
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 22.921,
			cy: 6.472,
			r: .809
		}),
		/* @__PURE__ */ _jsx("path", { d: "M16.179,8.571a.75.75,0,0,1-.53-1.28l5.124-5.124a.75.75,0,0,1,1.06,1.061L16.709,8.352A.747.747,0,0,1,16.179,8.571Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M14.016,9.979C11.789,7.763,8.694,6.36,7.086,7.966a1.9,1.9,0,0,0-.358.485C6.691,8.514.28,20.519.28,20.519a2.364,2.364,0,0,0,3.194,3.2l12-6.417a1.807,1.807,0,0,0,.564-.4C17.64,15.3,16.236,12.21,14.016,9.979Zm.491,5.409,0,0,0,0Zm.037-.027.008-.005Zm-.033.024,0,0c-.016.016-.061.074-.251.065-.908,0-2.6-1.083-3.614-2.1-1.519-1.52-2.373-3.522-2.028-3.868a.371.371,0,0,1,.248-.062A6.312,6.312,0,0,1,12.491,11.5C14.39,13.413,14.74,15.155,14.511,15.385Z" })
	]
});
export default SvgPartyConfetti;
